module.exports = __webpack_public_path__ + "assets/img/11.c27e3e7f.png";